/* Mille & Lykke – Adventskalender: video, 3D og animationer (hører til sections/ml-adventskalender-v3.liquid) */
(function () {
  'use strict';
  if (window.MLAFX) return;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var MOB = window.matchMedia('(max-width: 749px)');
  var HAS_IO = 'IntersectionObserver' in window;
  var inst = new Map();

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
  function listen(st, el, ev, fn, o) {
    if (!el) return;
    if (el.addEventListener) el.addEventListener(ev, fn, o); else if (el.addListener) el.addListener(fn);
    st.off.push(function () { if (el.removeEventListener) el.removeEventListener(ev, fn, o); else if (el.removeListener) el.removeListener(fn); });
  }

  /* ---------------- Video ---------------- */
  function initVideos(root, st) {
    each(root, '[data-vid]', function (box) {
      var all = Array.prototype.slice.call(box.querySelectorAll('video'));
      if (!all.length) return;
      var auto = box.dataset.autoplay === 'true' && !RM.matches;
      var want = auto, seen = false, v = null;
      var pb = box.querySelector('[data-play]'), sb = box.querySelector('[data-sound]'), big = box.querySelector('[data-bigplay]');

      function pick() {
        var m = box.querySelector('video.v-mob'), d = box.querySelector('video.v-desk');
        var a = (MOB.matches && m) ? m : (d || m);
        var muted = v ? v.muted : true;
        all.forEach(function (x) { x.hidden = x !== a; if (x !== a && !x.paused) x.pause(); });
        a.muted = muted;
        return a;
      }
      function ui() {
        var playing = v && !v.paused;
        box.classList.toggle('is-playing', !!playing);
        if (pb) { pb.classList.toggle('on', !!playing); pb.setAttribute('aria-label', playing ? pb.dataset.pauseL : pb.dataset.playL); }
        if (sb) { sb.classList.toggle('on', !v.muted); sb.setAttribute('aria-pressed', String(!v.muted)); sb.setAttribute('aria-label', v.muted ? sb.dataset.onL : sb.dataset.offL); }
      }
      function play() {
        var p = v.play();
        if (p && p.catch) p.catch(function (err) {
          if (err && err.name === 'NotAllowedError') { want = false; box.classList.add('manual'); ui(); }
        });
      }
      function sync() { if (want && seen) play(); else if (!v.paused) v.pause(); }

      v = pick();
      if (!auto) box.classList.add('manual');
      all.forEach(function (x) {
        listen(st, x, 'playing', function () { box.classList.add('started'); ui(); });
        listen(st, x, 'pause', ui);
      });
      listen(st, MOB, 'change', function () { var was = v && !v.paused; v = pick(); if (was) play(); ui(); });

      function toggle() {
        if (v.paused) { want = true; box.classList.remove('manual'); play(); }
        else { want = false; v.pause(); }
      }
      listen(st, pb, 'click', toggle);
      listen(st, big, 'click', toggle);
      listen(st, sb, 'click', function () {
        v.muted = !v.muted;
        if (!v.muted && v.paused) { want = true; box.classList.remove('manual'); play(); }
        ui();
      });

      if (HAS_IO) {
        var io = new IntersectionObserver(function (en) { seen = en[en.length - 1].isIntersecting; sync(); }, { threshold: 0.25 });
        io.observe(box); st.io.push(io);
      } else { seen = true; sync(); }
      ui();
    });
  }

  /* ---------------- Hjælpere til effekter ---------------- */
  function splitText(h) {
    if (h.dataset.splitDone) return;
    var txt = h.textContent.replace(/\s+/g, ' ').trim();
    if (!txt) return;
    h.dataset.splitDone = '1';
    h.setAttribute('aria-label', txt);
    var i = 0, html = txt.split(' ').map(function (w) {
      var chars = Array.prototype.map.call(w, function (c) {
        return '<span class="ch" style="--i:' + (i++) + '">' + c.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>';
      }).join('');
      return '<span class="wd" aria-hidden="true">' + chars + '</span>';
    }).join(' ');
    h.innerHTML = html;
  }

  function reveals(root, st) {
    var groups = new Map();
    each(root, '[data-rv]', function (el) {
      var p = el.parentNode, n = groups.get(p) || 0;
      groups.set(p, n + 1);
      el.style.setProperty('--d', (Math.min(n, 6) * 0.08) + 's');
      el.classList.add('rv');
    });
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    each(root, '.rv', function (el) { io.observe(el); });
    st.io.push(io);
  }

  function tilt(el, st, max) {
    var raf = 0, px = 0.5, py = 0.5;
    function apply() {
      raf = 0;
      el.style.setProperty('--ry', ((px - 0.5) * 2 * max).toFixed(2) + 'deg');
      el.style.setProperty('--rx', ((0.5 - py) * 2 * max).toFixed(2) + 'deg');
      el.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
      el.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      if (el.matches('[data-stage]')) el.style.transform = 'perspective(1200px) rotateX(var(--rx)) rotateY(var(--ry))';
    }
    listen(st, el, 'pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = el.getBoundingClientRect();
      px = clamp((e.clientX - r.left) / r.width, 0, 1);
      py = clamp((e.clientY - r.top) / r.height, 0, 1);
      el.classList.add('tilting');
      if (!raf) raf = requestAnimationFrame(apply);
    });
    listen(st, el, 'pointerleave', function () {
      el.classList.remove('tilting');
      px = py = 0.5; apply();
      if (el.matches('[data-stage]')) el.style.transform = '';
    });
  }

  function magnetic(btn, st) {
    listen(st, btn, 'pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = btn.getBoundingClientRect();
      var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
      var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
      btn.style.transform = 'translate3d(' + (clamp(dx, -1, 1) * 6).toFixed(1) + 'px,' + (clamp(dy, -1, 1) * 4).toFixed(1) + 'px,0)';
    });
    listen(st, btn, 'pointerleave', function () { btn.style.transform = ''; });
  }

  function glimmer(canvas) {
    var ctx = canvas.getContext('2d'); if (!ctx) return null;
    var n = MOB.matches ? 18 : 36, ps = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    function size() {
      var r = canvas.getBoundingClientRect();
      w = r.width; h = r.height;
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(p, fresh) {
      p.x = Math.random() * w; p.y = fresh ? Math.random() * h : h + 10;
      p.r = 0.6 + Math.random() * 1.5; p.vy = 6 + Math.random() * 14; p.vx = (Math.random() - 0.5) * 6;
      p.ph = Math.random() * Math.PI * 2; p.tw = 0.8 + Math.random() * 1.6;
      return p;
    }
    size();
    for (var i = 0; i < n; i++) ps.push(spawn({}, true));
    return {
      resize: size,
      draw: function (dt, t) {
        ctx.clearRect(0, 0, w, h);
        for (var i = 0; i < ps.length; i++) {
          var p = ps[i];
          p.y -= p.vy * dt; p.x += p.vx * dt;
          if (p.y < -10) spawn(p, false);
          var a = 0.25 + 0.55 * (0.5 + 0.5 * Math.sin(t * p.tw + p.ph));
          var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
          g.addColorStop(0, 'rgba(255,246,226,' + a.toFixed(3) + ')');
          g.addColorStop(1, 'rgba(232,212,170,0)');
          ctx.fillStyle = g;
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 4, 0, Math.PI * 2); ctx.fill();
        }
      }
    };
  }

  /* ---------------- Init ---------------- */
  function init(root) {
    if (!root || inst.has(root)) return;
    var st = { io: [], off: [], raf: 0 };
    inst.set(root, st);

    initVideos(root, st);

    if (root.dataset.fx !== 'true' || RM.matches || !HAS_IO) return;
    root.classList.add('fx-on');

    // Hero: split-text + reveal
    each(root, '.cover [data-split]', splitText);
    requestAnimationFrame(function () { requestAnimationFrame(function () { each(root, '[data-cover]', function (c) { c.classList.add('in'); }); }); });

    reveals(root, st);

    if (FINE.matches) {
      each(root, '.week [data-tilt]', function (el) { tilt(el, st, 8); });
      each(root, '.vid [data-stage][data-tilt]', function (el) { tilt(el, st, 7); });
      each(root, '.btn', function (b) { if (!b.closest('.mbar')) magnetic(b, st); });
    }

    // Scroll-drevne effekter: kører kun, mens elementet er i viewport
    var items = [], live = new Set();
    each(root, '[data-cover]', function (c) {
      var imgs = c.querySelectorAll('.media img');
      if (imgs.length) items.push({ el: c, fn: function (p, r) {
        var y = clamp(-r.top * 0.1, 0, r.height * 0.1).toFixed(1);
        for (var i = 0; i < imgs.length; i++) imgs[i].style.transform = 'translate3d(0,' + y + 'px,0) scale(1.1)';
      } });
      var cv = c.querySelector('[data-glim]');
      if (cv) {
        var g = glimmer(cv);
        if (g) { items.push({ el: c, anim: true, fn: function (p, r, dt, t) { g.draw(dt, t); } }); listen(st, window, 'resize', g.resize); }
      }
    });
    each(root, '[data-zoom]', function (tile) {
      var img = tile.querySelector('img'); if (!img) return;
      items.push({ el: tile, fn: function (p) { img.style.transform = 'scale(' + (1.14 - 0.14 * clamp(p * 1.6, 0, 1)).toFixed(4) + ')'; } });
    });
    each(root, '[data-stage]', function (stg) {
      var fx = stg.dataset.vfx, fr = stg.querySelector('.frame');
      if (fx === 'scale') items.push({ el: stg.closest('[data-vid]'), fn: function (p) {
        var q = clamp(p * 2.2, 0, 1), e = 1 - Math.pow(1 - q, 3);
        stg.style.transform = 'scale(' + (0.74 + 0.26 * e).toFixed(4) + ')';
      } });
      if (fx === 'reveal' && fr) items.push({ el: stg.closest('[data-vid]'), fn: function (p) {
        var q = clamp(p * 2.2, 0, 1), e = 1 - Math.pow(1 - q, 3), c = ((1 - e) * 22).toFixed(2);
        fr.style.clipPath = 'inset(' + c + '% ' + c + '% ' + c + '% ' + c + '%)';
      } });
    });
    each(root, '[data-marquee]', function (mq) {
      var t = mq.querySelector('.mq-t'), g = mq.querySelector('.mq-g');
      if (!t || !g) return;
      var x = 0, base = parseFloat(mq.dataset.speed) || 40, gw = g.offsetWidth;
      listen(st, window, 'resize', function () { gw = g.offsetWidth; });
      items.push({ el: mq, anim: true, fn: function (p, r, dt, time, vel) {
        var boost = 1 + clamp(Math.abs(vel) / 6, 0, 5);
        x -= base * boost * dt;
        if (gw && x <= -gw) x += gw;
        t.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      } });
    });

    if (!items.length) return;

    var vio = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        items.forEach(function (it) { if (it.el === x.target) { if (x.isIntersecting) live.add(it); else live.delete(it); } });
      });
      if (live.size && !st.raf) { last = 0; st.raf = requestAnimationFrame(loop); }
    }, { rootMargin: '10% 0px' });
    items.forEach(function (it) { vio.observe(it.el); });
    st.io.push(vio);

    var last = 0, lastY = window.scrollY, vel = 0, dirty = true;
    listen(st, window, 'scroll', function () { dirty = true; }, { passive: true });
    listen(st, window, 'resize', function () { dirty = true; });

    function loop(now) {
      st.raf = 0;
      if (!live.size) return;
      var dt = last ? Math.min((now - last) / 1000, 0.05) : 0.016; last = now;
      var y = window.scrollY; vel = vel * 0.85 + (y - lastY) * 0.15; lastY = y;
      var vh = window.innerHeight, list = [];
      live.forEach(function (it) {
        if (!it.anim && !dirty) return;
        var r = it.el.getBoundingClientRect();
        list.push([it, r, clamp((vh - r.top) / (vh + r.height), 0, 1)]);
      });
      for (var i = 0; i < list.length; i++) list[i][0].fn(list[i][2], list[i][1], dt, now / 1000, vel);
      dirty = Math.abs(vel) > 0.05;
      st.raf = requestAnimationFrame(loop);
    }
  }

  function destroy(root) {
    var st = inst.get(root); if (!st) return;
    if (st.raf) cancelAnimationFrame(st.raf);
    st.io.forEach(function (o) { o.disconnect(); });
    st.off.forEach(function (f) { f(); });
    inst.delete(root);
  }

  function initAll(scope) { each(scope || document, '[data-mla]', init); }

  window.MLAFX = { init: init, destroy: destroy };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { each(e.target, '[data-mla]', destroy); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    if (b && b.classList) { each(b, '.rv', function (el) { el.classList.add('in'); }); if (b.classList.contains('rv')) b.classList.add('in'); }
  });
})();
